import ActionSteps from "./ActionSteps";
import Feedback from "./Feedback";
import Solution from "./Solution";
import Transcript from "./TranscriptComp";

export const feedbackTabs = [
  {
    label: "Transcript",
    route: "transcript",
    Component: () => <Transcript />,
  },
  {
    label: "Feedback",
    route: "feedback",
    Component: () => <Feedback />,
  },
  {
    label: "Action Steps",
    route: "action-steps",
    Component: () => <ActionSteps />,
  },
  {
    label: "Solution",
    route: "solution",
    Component: () => <Solution />,
  },
];
